import { makeRequest } from "./client";
import type {
  Signature,
  SignatureInput,
} from "../../domain/signatures/signatures";

/** A Signature as the server stores it. */
export type ApiSignature = Signature & {
  organizationId: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
};

const signaturePath = (signatureId: string) =>
  `/v1/signatures/${encodeURIComponent(signatureId)}`;

const authHeaders = (token: string) => ({ Authorization: `Bearer ${token}` });

export const signaturesApi = {
  list: async (token: string): Promise<{ signatures: ApiSignature[] }> =>
    makeRequest<{ signatures: ApiSignature[] }>("/v1/signatures", {
      method: "GET",
      headers: authHeaders(token),
    }),

  create: async (
    input: SignatureInput,
    token: string,
  ): Promise<{ signature: ApiSignature }> =>
    makeRequest<{ signature: ApiSignature }>("/v1/signatures", {
      method: "POST",
      headers: authHeaders(token),
      body: JSON.stringify(input),
    }),

  /** Awards that already copied this Signature keep their copy. */
  update: async (
    signatureId: string,
    input: SignatureInput,
    token: string,
  ): Promise<{ signature: ApiSignature }> =>
    makeRequest<{ signature: ApiSignature }>(signaturePath(signatureId), {
      method: "PUT",
      headers: authHeaders(token),
      body: JSON.stringify(input),
    }),

  /** Awards that already copied this Signature keep their copy. */
  delete: async (
    signatureId: string,
    token: string,
  ): Promise<{ message: string }> =>
    makeRequest<{ message: string }>(signaturePath(signatureId), {
      method: "DELETE",
      headers: authHeaders(token),
    }),
};
